'use client';

import { BlocksContent } from '@strapi/blocks-react-renderer';

import GlobalBlockRenderer, {
  GlobalHeadingRenderer,
} from '@/components/ContentBlocks/GlobalBlockRenderer/GlobalBlockRenderer';

interface ParsePillHeadingProps {
  title: string;
  pillIndicator?: string;
  textColor?: string;
  center?: boolean;
}

export function ParsePillHeading({
  title,
  pillIndicator = '_',
  textColor,
  center = true,
}: ParsePillHeadingProps) {
  const parts = title.split(pillIndicator);

  const children = parts.map((part, index) => {
    const text = index % 2 === 1 ? part.trim() : part;
    const isBold = index % 2 === 1;

    return {
      type: 'text' as const,
      text,
      bold: isBold,
    };
  });

  const content: BlocksContent = [
    {
      type: 'heading',
      level: 2,
      children,
    },
  ];

  return (
    <GlobalBlockRenderer
      content={content}
      textColor={textColor}
      overrides={{
        blocks: {
          heading: GlobalHeadingRenderer({
            center,
            textColor,
            forceHeadingLevel: 2,
          }),
        },
      }}
    />
  );
}
